export const POSTHOG_FEATURE_FLAGS = {
  AD_REGISTRIES: 'ad_registries',
  AD_DISBURSEMENTS: 'ad_disbursements',
  AD_BANK_DETAILS_READ: 'ad_bank_details_read',
  AD_BANK_DETAILS_SUBMIT: 'ad_bank_details_submit',
  AD_BANK_DETAILS_REVIEW_APPROVAL: 'ad_bank_details_review_approval',
  AD_BANK_DETAILS_REVIEW_DELETE: 'ad_bank_details_review_delete',
  AD_BANK_DETAILS_REVIEW_ADD_NOTE: 'ad_bank_details_review_add_note',
  AD_BANK_DETAILS_VALIDATION: 'ad_bank_details_validation',
  BANK_DETAILS_VALIDATION_WITH_DOCUMENT: 'bank_details_validation_with_document',
  AD_BANK_DETAILS_REVIEW_UPLOAD_DOCUMENTS: 'ad_bank_details_review_upload_documents',
  AD_PAYMENT_METHODS_READ: 'ad_payment_methods_read',
  AD_PAYMENT_METHODS_SUBMIT: 'ad_payment_methods_submit',
  AD_MARK_ORGANISATION_UNPAYABLE: 'ad_mark_organisation_unpayable',
  AD_DONATION_REQUESTS: 'ad_donation_requests',
  AD_DONATION_MATCH_REQUESTS: 'ad_donation_match_requests',
  AD_DONATIONS_TABLE: 'ad_donations_table',
  AD_REASSIGN_DONATION: 'ad_reassign_donation',
  AD_EDIT_REGISTRATION_STATUS: 'ad_edit_registration_status',
  AD_REGISTRIES_REQUIRED_TYPES: 'ad_registries_required_types',
  AD_EDIT_OFFICIAL_DETAILS: 'ad_edit_official_details',
  AD_EDIT_BRAND_DETAILS: 'ad_edit_brand_details',
  AD_EDIT_CONTACTS_DETAILS: 'ad_edit_contacts_details',
  AD_EDIT_LOCATION_DETAILS: 'ad_edit_location_details',
  AD_ADD_ORG: 'ad_add_org',
  AD_EDIT_UNCLAIM_ORG: 'ad_edit_unclaim_org',
  AD_ADD_ORG_FILE: 'ad_add_org_file',
  AD_AGENT_VERIFICATION_MANUAL_FRAUDLENT_REJECTION: 'ad_agent_verification_manual_fraudlent_rejection',
  AD_NONE_OF_THE_ABOVE_EDU_SUBTAGS: 'ad_none_of_the_above_edu_subtags',
  AD_UNREJECT_CLAIM: 'ad_unreject_claim',
  AD_BATCH_UPDATE_ORGANISATIONS: 'ad_batch_update_organisations',
  AD_AUTO_REJECTION_LIST: 'ad_auto_rejection_list',
  AD_REGISTRIES_SUPPORTED_TYPES: 'ad_registries_supported_types',
  AD_DYNAMIC_AGENT_VERIFICATION: 'ad_dynamic_agent_verification',
  AD_BANK_DETAILS_REVIEW_TIMELINE: 'ad_bank_details_review_timeline',
  AD_AUTO_FRAUD_CHECKS: 'ad_auto_fraud_checks',
  AD_AUTO_ALLOW_LIST: 'ad_auto_allow_list',
  AD_VR_BLOCK_LIST: 'ad_vr_block_list',
  AD_PROGRAM_LIST: 'ad_program_list',
  AD_ADD_NEW_PROGRAM: 'ad_add_new_program',
  AD_RESUBMIT_FLAGS: 'ad_resubmit_flags',
  AD_UPLOAD_ORG_IMAGES: 'ad_upload_org_images',
  AD_GRANT_PROGRAMS: 'ad_grant_programs',
  AD_DISBURSEMENTS_BATCH_PARTNER_FILTER: 'ad_disbursements_batch_partner_filter',
  AD_DONATION_IMPORT_WITH_DISBURSEMENT_CONFIG: 'ad_donation_import_with_disbursement_config',
  AD_DONATION_STANDALONE: 'ad_donation_standalone',
  AD_DISBURSEMENT_DONATIONS_VIEW: 'ad_disbursement_donations_view',
  AD_VS_REDEMPTION: 'ad_vs_redemption',
  INTERNAL_FGA_ORGV_REDEMPTIONS: 'internal_fga_orgv_redemptions',
  INTERNAL_FGA_ORGV_REGISTRIES: 'internal_fga_orgv_registries',
  INTERNAL_FGA_ORGV_VALIDATION_REQUEST_BLOCKLIST: 'internal_fga_orgv_validation_request_blocklist',
  INTERNAL_FGA_ORGV_VERIFICATIONS_ALLOW_LIST: 'internal_fga_orgv_verifications_allow_list',
  INTERNAL_FGA_ORGV_AGENT_VERIFICATIONS_AUTO_REJECTION_LIST:
    'internal_fga_orgv_agent_verifications_auto_rejection_list',
  INTERNAL_FGA_ORGV_VALIDATION_SUBMISSION_CONFIGURATIONS: 'internal_fga_orgv_validation_submission_configurations',
  INTERNAL_FGA_ORGV_VALIDATION_SUBMISSIONS: 'internal_fga_orgv_validation_submissions',
  INTERNAL_FGA_ORGV_VALIDATION_REQUESTS: 'internal_fga_orgv_validation_requests',
  INTERNAL_FGA_ORGV_ORGANISATIONS: 'internal_fga_orgv_organisations',
  INTERNAL_FGA_ORGV_ORGANISATION_PROFILES: 'internal_fga_orgv_organisation_profiles',
  INTERNAL_FGA_ORGV_VETTING_EVENTS: 'internal_fga_orgv_vetting_events',
  INTERNAL_FGA_ORGV_ELIGIBILITY_SUBSCRIPTIONS: 'internal_fga_orgv_eligibility_subscriptions',
  INTERNAL_FGA_ORGV_VALIDATION_STATIC_LINKS: 'internal_fga_orgv_validation_static_links',
  INTERNAL_FGA_ORGV_ACTIVITY: 'internal_fga_orgv_activity',
  INTERNAL_FGA_ORGV_RALPH_ORACLE: 'internal_fga_orgv_ralph_oracle',
  AD_LOG_RETURNED_PAYMENT: 'ad_log_returned_payment',
  AD_DONATION_REQUESTS_DONATION_KIND_FILTER: 'ad_donation_requests_donation_kind_filter',
  INTERNAL_FGA_DORA_DONATION_REQUESTS: 'internal_fga_dora_donation_requests',
  INTERNAL_FGA_DORA_DONATIONS: 'internal_fga_dora_donations',
  INTERNAL_FGA_DORA_DISBURSEMENTS: 'internal_fga_dora_disbursements',
  INTERNAL_FGA_DORA_BANK_DETAILS_PAYMENT_METHODS: 'internal_fga_dora_bank_details_payment_methods',
  INTERNAL_FGA_GIVING_DONATION_MATCH_REQUESTS: 'internal_fga_giving_donation_match_requests',
  AD_TRIGGER_EMAIL_VERIFICATION: 'ad_trigger_email_verification',
  AD_STATIC_LINKS: 'ad_static_links',
  AD_DISBURSEMENT_CANCELLATION_REASON: 'ad_disbursement_cancellation_reason',
  AD_MULTI_APPROVAL: 'ad_multi_approval',
  AD_BENEFICIARIES: 'ad_beneficiaries',
  INTERNAL_FGA_GRANTS: 'internal_fga_grants',
  AD_VR_REVIEW_WEBSITE: 'ad_vr_review_website',
  AD_DISBURSEMENT_BANK_DETAILS_LINK: 'ad_disbursement_bank_details_link',
  AD_SUBMIT_QC: 'ad_submit_qc',
  AD_SEWA_ONBOARDING: 'can_read_sewa',
  AD_RALPH_ORACLE: 'ad_ralph_oracle',
  AD_DISBURSEMENTS_LIST_V2: 'ad_disbursements_list_v2',
  AD_ROLES_VIEW: 'ad_roles_view',
  AD_EFFECTIVE_ROLES: 'ad_effective_roles',
  AD_VALIDATION_SUBMISSION_HOLDS: 'ad_validation_submission_holds',
  AD_SERVICES: 'ad_services',
  AD_COLLAPSIBLE_SIDE_NAV: 'ad_collapsible_side_nav',
  AD_VR_DOCUMENT_REQUEST: 'ad_vr_document_request'
} as const

export type PostHogFeatureFlag = typeof POSTHOG_FEATURE_FLAGS[keyof typeof POSTHOG_FEATURE_FLAGS]
